var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHammerLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hammer-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1667 1.6665C17.6269 1.6665 18 2.0396 18 2.49984V6.6665C18 7.12674 17.6269 7.49984 17.1667 7.49984H13V18.3332C13 18.7934 12.6269 19.1665 12.1667 19.1665H8.83333C8.3731 19.1665 8 18.7934 8 18.3332V7.49984H3.41666C2.95643 7.49984 2.58333 7.12674 2.58333 6.6665V4.68153C2.58333 4.36589 2.76166 4.07734 3.04399 3.93618L7.58333 1.6665H17.1667ZM13 3.33317H7.97678L4.24999 5.19656V5.83317H9.66666V17.4998H11.3333V5.83317H13V3.33317ZM16.3333 3.33317H14.6667V5.83317H16.3333V3.33317Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerLine);
export default __webpack_public_path__ + "static/media/hammer-line.d772227ccbffd6177dd78f4ef7c1db37.svg";
export { ForwardRef as ReactComponent };